export default function Destinations() {
  const destinations = [
    {
      name: 'Saudi Arabia',
      image: 'https://public.readdy.ai/ai/img_res/b5a8f214113bfce5fd49b78661f86eb0.jpg',
      color: 'bg-[#F4E4E8]',
      description: 'Makkah, Madinah, Riyadh & Jeddah'
    },
    {
      name: 'Turkey',
      image: 'https://readdy.ai/api/search-image?query=Istanbul%20Blue%20Mosque%20Sultan%20Ahmed%20Mosque%20at%20golden%20hour%20with%20beautiful%20domes%20and%20minarets%2C%20clear%20blue%20sky%2C%20architectural%20magnificence%2C%20professional%20travel%20photography%2C%20warm%20lighting%2C%20iconic%20Turkish%20landmark%2C%20elegant%20composition%2C%20cultural%20heritage%20site%2C%20high%20quality%20photography&width=600&height=800&seq=turkey-istanbul-001&orientation=portrait',
      color: 'bg-[#E8F4F0]',
      description: 'Istanbul, Cappadocia & Antalya'
    },
    {
      name: 'United Arab Emirates',
      image: 'https://readdy.ai/api/search-image?query=Sheikh%20Zayed%20Grand%20Mosque%20Abu%20Dhabi%20with%20stunning%20white%20marble%20architecture%20and%20golden%20domes%2C%20clear%20blue%20sky%2C%20majestic%20Islamic%20architecture%2C%20professional%20travel%20photography%2C%20pristine%20and%20elegant%2C%20cultural%20landmark%2C%20high%20quality%20architectural%20photography%2C%20peaceful%20atmosphere&width=600&height=800&seq=uae-abudhabi-001&orientation=portrait',
      color: 'bg-[#F0F0F0]',
      description: 'Dubai, Abu Dhabi & Sharjah'
    },
    {
      name: 'Jordan',
      image: 'https://readdy.ai/api/search-image?query=Petra%20Treasury%20Al-Khazneh%20ancient%20carved%20rose-red%20stone%20facade%20in%20Jordan%2C%20dramatic%20natural%20lighting%2C%20archaeological%20wonder%2C%20professional%20travel%20photography%2C%20warm%20sandstone%20colors%2C%20historical%20landmark%2C%20majestic%20and%20timeless%2C%20high%20quality%20heritage%20site%20photography&width=600&height=800&seq=jordan-petra-001&orientation=portrait',
      color: 'bg-[#F4EDE4]',
      description: 'Petra, Amman & Dead Sea'
    }
  ];

  return (
    <section id="destinations" className="py-32 bg-[#FAF8F5]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <p className="text-[#C9A961] text-lg mb-4 italic" style={{ fontFamily: 'Playfair Display, serif' }}>
            /Explore Our Regions
          </p>
          <h2 className="text-6xl lg:text-7xl font-bold text-[#3A2F2B] leading-tight max-w-4xl" style={{ fontFamily: 'Playfair Display, serif' }}>
            Discover hand-selected <span className="italic font-normal">destinations across the Middle East</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {destinations.map((destination, index) => (
            <div
              key={index}
              className="group cursor-pointer"
            >
              <div className={`${destination.color} rounded-3xl overflow-hidden h-[500px] transition-all duration-300 hover:shadow-2xl hover:-translate-y-2`}>
                <div className="h-[85%] overflow-hidden">
                  <img
                    src={destination.image}
                    alt={destination.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="h-[15%] bg-white flex items-center justify-between px-6">
                  <div>
                    <h3 className="font-bold text-[#1A1F2E] text-lg">{destination.name}</h3>
                    <p className="text-sm text-gray-600">{destination.description}</p>
                  </div>
                  <i className="ri-arrow-right-line text-[#C9A961] text-xl group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button 
            onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
            className="px-8 py-4 bg-[#1A1F2E] text-white rounded-lg text-base font-semibold hover:bg-[#2A3F4E] transition-all whitespace-nowrap cursor-pointer"
          >
            View All Destinations
          </button>
        </div>
      </div>
    </section>
  );
}
